// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rrq_","fullView":"styles_fullView__QDSKe"};